// What each browser's fetch() rejects with when the request never got an
// answer: offline, a dropped connection, or a blocker extension refusing the
// host. Not a bug in our code and nothing we can fix from here.
export const NETWORK_FAILURE_MESSAGES = new Set([
  'Load failed', // Safari
  'Failed to fetch', // Chrome
  'NetworkError when attempting to fetch resource.', // Firefox
])

export function is_network_failure(error: unknown): boolean {
  return (
    error instanceof TypeError && NETWORK_FAILURE_MESSAGES.has(error.message)
  )
}
